import { userService } from '../_services'
import { router } from '../_router/router'

const loggedInUser = JSON.parse(localStorage.getItem('app_user'))
const initialState = loggedInUser
    ? {
          status: {
              loggedIn: true
          },
          loggedInUser
      }
    : {
          status: {},
          loggedInUser: null
      }

export const authentication = {
    namespaced: true,
    state: initialState,
    actions: {
        login({ commit }, { email, password }) {
            commit('loginRequest', {
                email
            })

            userService.login(email, password).then(
                loggedInUser => {
                    commit('loginSuccess', loggedInUser)
                    router.push('/dashboard')
                },
                error => {
                    commit('loginFailure', error)
                }
            )
        },
        logout({ commit }) {
            userService.logout()
            commit('logout')
        }
    },
    mutations: {
        loginRequest(state) {
            state.status = {
                loggingIn: true
            }
        },
        loginSuccess(state, user) {
            state.status = {
                loggedIn: true
            }
            state.loggedInUser = user
        },
        loginFailure(state) {
            state.status = {}
            state.loggedInUser = null
        },
        logout(state) {
            state.status = {}
            state.loggedInUser = null
        }
    }
}
